import { IPurchasingGroupSettingsDto } from '../types/purchasing-group-settings.dto';

export class PurchasingGroupSettings {
    public readonly required: boolean;
    public readonly showDuringOrderingProcess: boolean;
    public readonly firstMatchRuleSetActive: boolean;
    public readonly defaultPurchasingGroupId: string | null;

    constructor(dto: IPurchasingGroupSettingsDto) {
        this.required = dto.required;
        this.showDuringOrderingProcess = dto.showDuringOrderingProcess;
        this.firstMatchRuleSetActive = dto.firstMatchRuleSetActive;
        this.defaultPurchasingGroupId = dto.defaultPurchasingGroupId ?? null;
    }
}
